var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border"},[_c('div',{staticStyle:{"padding":"1rem"}},[_c('PageHeader',{attrs:{"title":"สถิติถูกผิดของคำถามแต่ละข้อ"}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('questionOverview',{attrs:{"apiRoute":`exams/${_vm.examId}/get-answer-stat-by-exam-id`,"perPage":20,"bestScoreSelected":_vm.bestScoreSelected}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }